export default __webpack_public_path__ + "static/media/bs-5.0f5f6f04.png";